// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import window from 'global';

export function api() {
	// For apps/frontend
	if (import.meta?.env?.VITE_API_ENDPOINT) {
		return import.meta.env.VITE_API_ENDPOINT;
	}

	return `${window.location.origin}/api/v1/`;
}

export function apiWithoutTrailSlash() {
	const res = api();
	return res.endsWith('/') ? res.slice(0, -1) : res;
}

/** Base URL for v2: origin only. v2 paths already include /api/v2/... so we must not add /api again. */
export function apiBaseWithoutTrailSlash(url?: string) {
	const res = url || api();
	const withoutSlash = res.endsWith('/') ? res.slice(0, -1) : res;
	// Strip version segment then /api so base is origin-only (v2 paths are /api/v2/...)
	const withoutVersion = withoutSlash.replace(/\/v\d+$/, '') || withoutSlash;
	return withoutVersion.replace(/\/api$/, '') || withoutVersion;
}
